import VueRouter, { Route } from 'vue-router'

export const queryToString = (value: string | (string | null)[] | undefined): string | undefined => {
  return Array.isArray(value) ? value[0] || undefined : value
}

export const paths = {
  VIEWER: '/viewer',
  ANSWER_AND_IDEAS: '/answersAndIdeas',
  FULL_DIGITAL_TATEGAKI: '/fullDigitalTategaki',
  FULL_DIGITAL_YOKOGAKI: '/fullDigitalYokogaki',
  FULL_DIGITAL_TEISHUTSU_TATEGAKI: '/fullDigitalTeishutsuTategaki',
  FULL_DIGITAL_TEISHUTSU_YOKOGAKI: '/fullDigitalTeishutsuYokogaki',
  PREVIEW: '/submitPreview',
  TEISHUTSU_PREVIEW: '/teishutsuPreview',
} as const

export class RouterUtil {
  static ROUTE_BY_BACK_FLG_KEY = 'routeByBackFlg'
  static FROM_PATH_HISTORIES_KEY = 'fromPathHistories'
  static FROM_PATH_HISTORIES_DELIMITER = ','

  /**
   * ヘッダの戻るアイコン押下時の処理
   * routeByBackFlgフラグを立て、履歴から取得したパスへ遷移する。
   *
   * @param router
   */
  static backToPrevious(router: VueRouter): void {
    sessionStorage.setItem(RouterUtil.ROUTE_BY_BACK_FLG_KEY, 'true')
    const backToPath = this.popHistory()
    router.push(backToPath)
  }

  /**
   * 戻るボタン押下による遷移かどうか?
   * @returns
   */
  static isRouteByBack(): boolean {
    if (!sessionStorage.getItem(RouterUtil.ROUTE_BY_BACK_FLG_KEY)) {
      return false
    }
    return JSON.parse(sessionStorage.getItem(RouterUtil.ROUTE_BY_BACK_FLG_KEY)!)
  }

  static resetRouteByBack(): void {}

  /**
   * 画面遷移の履歴を積む。
   * sessionStorageへカンマ区切りでパスを連結(前から新しい順)
   * @param from
   */
  static pushHistory(from: Route): void {
    let historiesNew = from.path

    // リロードするとroot pathが追加されるため、これは無視する
    if (historiesNew === '/') {
      return
    }

    const histories = sessionStorage.getItem(RouterUtil.FROM_PATH_HISTORIES_KEY)
    if (histories) {
      historiesNew = historiesNew + RouterUtil.FROM_PATH_HISTORIES_DELIMITER + histories
    }

    sessionStorage.setItem(RouterUtil.FROM_PATH_HISTORIES_KEY, historiesNew)
  }

  /**
   * 画面遷移の履歴から、最も新しい履歴を取得し、その履歴を削除する。
   * @returns
   */
  static popHistory(): string {
    const histories = sessionStorage.getItem(RouterUtil.FROM_PATH_HISTORIES_KEY)

    const list = histories!.split(RouterUtil.FROM_PATH_HISTORIES_DELIMITER)
    if (!list || list.length === 0) {
      // 履歴がなければトップを返す。
      return '/top'
    }

    // 先頭の履歴を取得し、その履歴は削除する。
    const ret = list[0]
    list.shift()
    sessionStorage.setItem(RouterUtil.FROM_PATH_HISTORIES_KEY, list.join(RouterUtil.FROM_PATH_HISTORIES_DELIMITER))

    return ret
  }

  /**
   * 画面遷移の履歴を全て削除する
   */
  static removeAllHistory(): void {
    sessionStorage.removeItem(RouterUtil.FROM_PATH_HISTORIES_KEY)
  }
}
